import { Route } from '@angular/router';

export const authRoutes: Route[] = [
  {
    path: 'sign-in',
    loadComponent: () => import('../pages/auth/sign-in/sign-in.page'),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('../pages/auth/sign-up/sign-up.page'),
  },
  {
    path: 'sign-up-complete',
    loadComponent: () =>
      import('../pages/auth/sign-up-complete/sign-up-complete.page'),
  },
  {
    path: 'find-email',
    loadComponent: () => import('../pages/auth/find-email/find-email.page'),
  },
  {
    path: 'find-password',
    loadComponent: () =>
      import('../pages/auth/find-password/find-password.page'),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('../pages/auth/reset-password/reset-password.page'),
  },
  {
    path: 'pin-reset',
    loadComponent: () => import('../pages/auth/pin-reset/pin-reset.page'),
  },
];
